import { CHECK_NATIVE_PERMISSION } from "core-lib/constants/nativeBridge";
import {
  passMessageToNative,
  waitForCustomEvent,
} from "core-lib/utils/nativeBridge";
import { useState } from "react";
enum NativePermissions {
  Granted = "GRANTED",
  Deny = "DENY",
  Disabled = "DISABLED",
}

export enum PermissionStatus {
  Success = "SUCCESS",
  Failed = "FAILED",
  Pending = "PENDING",
  Default = "DEFAULT",
}

export const useCheckNativePermission = (): {
  checkPermission: (permissionName: string) => Promise<void>;
  status: PermissionStatus;
} => {
  const [status, setStatus] = useState<PermissionStatus>(
    PermissionStatus.Default
  );

  const setPermissionStatus = (nativePermissionStatus: NativePermissions) => {
    if (nativePermissionStatus === NativePermissions.Granted) {
      setStatus(PermissionStatus.Success);
    } else if (
      [NativePermissions.Deny, NativePermissions.Disabled].includes(
        nativePermissionStatus
      )
    ) {
      setStatus(PermissionStatus.Failed);
    } else {
      setStatus(PermissionStatus.Pending);
    }
  };

  async function checkPermission(permissionName: string) {
    const callback_script: string = `try{
        const res = "{{status}}"
        window.dispatchEvent(new CustomEvent('CHECK_NATIVE_PERMISSION', {  detail: {res} }));
      } catch(e){
        console.error('callback_script error',e);
      }`;
    passMessageToNative(CHECK_NATIVE_PERMISSION, null, {
      permission_name: permissionName,
      callback_script,
    });

    const eventResponse: any = await waitForCustomEvent(
      "CHECK_NATIVE_PERMISSION"
    );
    setPermissionStatus(eventResponse?.detail?.res);
  }

  return { checkPermission, status };
};
